module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section07_02_american-village-0f633b750e0934f0d73068d79b9c8776.jpg";